import React  from 'react'
import { useState, useEffect } from "react";

import CaraAITitle from "./components/CaraAiTitle";
import { HiMiniCheckBadge } from "react-icons/hi2";
import { FaCheckCircle } from "react-icons/fa";
import FadeLoader from "react-spinners/FadeLoader";
import { Heading1, Paragraph1, BoxText, Silderlogos } from "../../../components/Ui";
import images from "../../../Utilities/index";
import { LandingPageTestimonial, FaqSection, IdealCustomers } from "../../../components/Ui/UiComponents";




export default function SalesAi() {
    let WorkingCara = [
        { img: images.UserImg, title: "Face Recognition", para: "Tell Cara About Your Business, Your Ideal Customer Profile, And Your Preferred Communication Style." },
        { img: images.SearchEngine, title: "Search Engine", para: "Work With Cara By Reviewing The Leads She Finds And The Outbound Messaging She Ghostwrites For You. Once You're On The Same Page, You Can Ask Her To Work Autonomously." },
        { img: images.Customers, title: "Technology For Generate Leads", para: "Cara Learns From Every Interaction, Making Your Campaigns Not Only Generate More Meetings, But Also The Right Ones, At Scale." },
    ]
    let DataConso = [
        { img: images.DatabaseIcon, title: "Data Aggregation", para: "Cara Works With Webtastic AI Nexus, Which Autonomously Indexes Web Data, Social Media, News, Interviews, And Podcasts, And Integrates With Over 50 B2B Data Providers, Including Linkedin, Apollo, And Google." },
        { img: images.YoutubeIcon, title: "Single Subscription", para: "With Cara Accessing The Precise Data You Need, There's No Need For Subscriptions To Multiple Costly Data Providers Or Worries About Missing Out On Any Other Tools." },
    ]
    let RightMessageAI = [
        { img: images.MagnetSearch, title: "Prospectiong", para: "Cara Scans Over 50 B2B Data Sources (Eg. Apollo, Hunter, Linkedin) To Help You Find ICP Leads In Buying Mode.", p1: "Web-, Social- And B2B Data", p2: "50+ B2B Data Sources", p3: "275M People" },
        { img: images.SearchMessage, title: "Research", para: "Next, Cara Conducts Detailed Research On Prospects She Found For You And Triple Verifies The Contact Details.", p1: "People & Company Research", p2: "Waterfall Lead Enrichment", p3: "Triple Verified Email Addresses" },
        { img: images.MesageSearch, title: "Search Engine", para: "Cara Ghostwrites 1:1 Hyper-Personalized Messages For Each Prospect And Sends Them At Most Likely To Engage.", p1: "1:1 Hyper Personalized Outreach", p2: "Messaging Based On Unique Hook", p3: "Sends At The Right Time" },
    ]
    const [loading, setLoading] = useState(false);
    const handleSubmit = () => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    }

    const [isRow, setIsRow] = useState(window.innerWidth >= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsRow(window.innerWidth >= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const styles = {
        section: {
            background: `url(${images.bannerBg}) center top/cover no-repeat`, // Moves focus to the top
            padding: "70px 0 170px",
            height: "600px",
            textAlign: "center",
        },        
        container: {
            display: "flex",
            flexDirection: isRow ? "row" : "column",
            alignItems: "center",
            textAlign: "center",
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 20px",
        },
        content: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            gap: "16px",
            maxWidth: "600px",
        },
        heading: {
            fontSize: "2rem",
            fontWeight: "700",
            lineHeight: "1.2",
        },
        list: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "12px",
            padding: "0",
            listStyle: "none",
        },
        listItem: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "16px",
        },
        form: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            maxWidth: "350px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "6px",
            overflow: "hidden",
        },
        input: {
            flex: 1,
            padding: "10px",
            border: "none",
            outline: "none",
            fontSize: "16px",
        },
        button: {
            backgroundColor: "black",
            color: "white",
            padding: "10px 16px",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            transition: "0.3s",
        },
        imageContainer: {
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
        },
        rating: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "14px",
            marginTop: "16px",
        },
    };
    
    
    return (
        <>
            {
                loading ?
                    <div className=' flex h-screen justify-center items-center'> <FadeLoader color="#56F444" /> </div>
                    :
                    <>
                    <section style={styles.section}>
                            <div style={{
                                display: "flex",
                                alignItems: "center", // Ensures vertical alignment
                                justifyContent: "space-between", // Distributes space properly
                                maxWidth: "1200px", 
                                margin: "0 auto", // Centers content
                                padding: "40px 20px",
                            }}>
                                {/* Left Content */}
                                <div style={{
                                    flex: 1, // Allows it to take available space
                                    maxWidth: "50%", // Limits width for better balance
                                    padding: "20px",
                                }}>
                                    <h3 style={{
                                        fontSize: "32px",
                                        fontWeight: "700",
                                        lineHeight: "1.4",
                                        color: "#333",
                                        textAlign: "left"
                                    }}>
                                        <span style={{ fontWeight: "400" }}>Hi, I'm Cara,</span> <br />
                                        <span style={{ fontWeight: "400" }}>Your </span>
                                        <span style={{ fontWeight: "700" }}>AI Sales Agent</span>
                                    </h3>



                                    <ul style={{ padding: "0", marginTop: "20px", listStyle: "none" }}>
                                        <li style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                            <FaCheckCircle  /> 
                                            I search 
                                            <img src={images.LinkedinImg} alt="LinkedIn" style={{ height: "20px" }} /> LinkedIn, 
                                            <img src={images.ApolloImg} alt="Apollo" style={{ height: "20px" }} /> Apollo, and 50+ sources to find leads.
                                        </li>
                                        <li style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                            <FaCheckCircle  /> 
                                            I ghostwrite personalized emails using 
                                            <img src={images.ChatgptImg} alt="ChatGPT" style={{ height: "20px" }} /> ChatGPT.
                                        </li>
                                        <li style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <FaCheckCircle  /> 
                                            I send them with your 
                                            <img src={images.GmailImg} alt="Gmail" style={{ height: "20px" }} /> Gmail Account.
                                        </li>
                                    </ul>

                                    <form onSubmit={handleSubmit} style={{ 
                                        display: "flex", 
                                        gap: "10px", 
                                        marginTop: "20px" 
                                    }}>
                                        <input 
                                            type="text" 
                                            placeholder="Enter your email" 
                                            style={{ 
                                                flex: 1, 
                                                padding: "10px", 
                                                borderRadius: "5px", 
                                                border: "1px solid #ccc" 
                                            }} 
                                        />
                                        <button style={{ 
                                            padding: "10px 20px", 
                                            backgroundColor: "#4CAF50", 
                                            color: "#fff", 
                                            borderRadius: "5px", 
                                            border: "none",
                                            cursor: "pointer"
                                        }}>
                                            Start Trial
                                        </button>
                                    </form>

                                    <div style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        gap: "10px", 
                                        marginTop: "15px", 
                                        fontSize: "14px", 
                                        color: "#555" 
                                    }}>
                                        <img src={images.GooglestoreImg} alt="Google Store" style={{ height: "20px" }} /> 
                                        4.8 / 5 in the Google Chrome Store
                                    </div>
                                </div>

                                {/* Right Image */}
                                <div style={{
                                    flex: 1,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    maxWidth: "50%",
                                }}>
                                    <img src={images.Aimainimg} alt="AI Agent" style={{ maxWidth: "100%", height: "auto" }} />
                                </div>
                            </div>
                        </section>


                        {/* Slider logos here */}
                        <section className="container" style={{ padding: "40px 0" }}>
                            <Silderlogos />
                        </section>

                        {/* working with cara in AI */}
                     <section style={{ 
                                display: "flex", 
                                flexDirection: "row", 
                                gap: "40px", 
                                margin: "60px 0", 
                                alignItems: "center"
                            }}>
                                {/* Left Side - Image with Green Background */}
                            <div style={{ 
                                width: "45%", 
                                position: "relative", 
                                borderRadius: "20px", 
                                padding: "40px", 
                                display: "flex", 
                                justifyContent: "center",
                                alignItems: "center" 
                            }}>
                                <img 
                                    src={images.WorkingAicara} 
                                    alt="Cara AI Working" 
                                    style={{ width: "70%", borderRadius: "12px" }} 
                                />
                            </div>

                                    {/* Right Side - Content */}
                                    <div style={{ 
                                        width: "50%", 
                                        padding: "2 15px", 
                                        display: "flex", 
                                        flexDirection: "column", 
                                        gap: "20px" 
                                    }}>
                                        {/* Title */}
                                        <CaraAITitle title="Let's Kick Off Our Collaboration, Here's How." />

                                        {/* Heading */}
                                        <h1 style={{ 
                                            fontSize: "28px", 
                                            fontWeight: "700", 
                                            textAlign: "left", 
                                            color: "#000" 
                                        }}>
                                            Start Working With Cara In Three Steps
                                        </h1>

                                        {/* Steps */}
                                        {WorkingCara.map((val, id) => (
                                            <div key={id} style={{ 
                                                display: "flex", 
                                                flexDirection: "row", 
                                                gap: "15px", 
                                                alignItems: "center",
                                                padding: "12px 0"
                                            }}>
                                                {/* Icon */}
                                                <div style={{ 
                                                    padding: "10px", 
                                                    borderRadius: "8px", 
                                                    display: "flex", 
                                                    justifyContent: "center", 
                                                    alignItems: "center"
                                                }}>
                                                    <img 
                                                        src={val.img} 
                                                        alt="Step Icon" 
                                                        style={{ width: "30px", height: "30px" }} 
                                                    />
                                                </div>

                                                {/* Text Content */}
                                                <div>
                                                    <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#000" }}>
                                                        {val.title}
                                                    </h4>
                                                    <p style={{ fontSize: "15px", color: "#555", lineHeight: "1.5" }}>
                                                        {val.para}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </section>


                        {/* right message section starts here */}
                       {/* Right Message Section */}
                       <section style={{ backgroundColor: "#ECFFF3", padding: "64px 0" }}>
    <div style={{ width: "90%", maxWidth: "1200px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "24px" }}>
        
        {/* Header Message */}
        <div style={{
            display: "flex", 
            alignItems: "center", 
            borderRadius: "50px", 
            padding: "8px 16px", 
            backgroundColor: "white", 
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            fontSize: "13px", 
            color: "#8a8a8a", 
            maxWidth: "fit-content"
        }}>
            <img src={images.Cara} alt="Cara AI" style={{ marginRight: "8px", width: "24px", height: "24px" }} />
            Here's Why You Should Hire Me Today.
        </div>

        {/* Heading */}
        <div style={{ maxWidth: "75%" }}>
            <Heading1 heading1="The Right Message, To The Right Person, At The Right Time, On Autopilot" />
        </div>

        {/* Paragraph */}
        <div style={{ maxWidth: "75%" }}>
            <Paragraph1 para1="Cara Automates Your Outreach Process, From Researching And Identifying The Right People, To Ghostwriting The Highest-Converting 1:1 Personalized Outbound Messages, Sent At The Right Time." />
        </div>

        {/* Feature Grid */}
        <div style={{
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", 
            gap: "24px"
        }}>
            {RightMessageAI.map((val, id) => (
                <div key={id} style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    textAlign: "center",
                    padding: "16px",
                    backgroundColor: "white",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
                }}>
                    {/* Image */}
                    <img src={val.img} alt="Feature Icon" style={{ width: "56px", height: "56px", margin: "0 auto" }} />

                    {/* Title */}
                    <h3 style={{ fontSize: "17px", fontWeight: "600", color: "#333" }}>{val.title}</h3>

                    {/* Description */}
                    <p style={{ fontSize: "15px", color: "#666" }}>{val.para}</p>

                    {/* Bullet Points */}
                    <ul style={{ display: "flex", flexDirection: "column", gap: "6px", listStyle: "none", padding: "0" }}>
                        {[val.p1, val.p2, val.p3].map((point, index) => (
                            <li key={index} style={{
                                display: "flex", 
                                alignItems: "center", 
                                fontSize: "15px", 
                                color: "#444"
                            }}>
                                <HiMiniCheckBadge style={{ color: "green", marginRight: "8px", width: "20px", height: "20px" }} />
                                {point}
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    </div>
</section>


                        {/* elevate strategy box  */}
                        <section className='container text-center my-5'>
                            <BoxText heading1="Empower Your Future: Take Charge Today!" para="Seize the opportunity to transform your approach to success. Click now to unlock the full potential of our features and revolutionize your business strategy." btn1="Start to Free" />
                        </section>
                        {/* All the Data in AI */}
                                            <section style={{
                        width: "90%", 
                        maxWidth: "1200px", 
                        margin: "40px auto 64px", 
                        display: "flex", 
                        flexDirection: "row", 
                        alignItems: "center", 
                        gap: "24px"
                    }}>
                        {/* Image Section */}
                        <div style={{ width: "100%", maxWidth: "600px" }}>
                            <img src={images.DataAi} alt="Data AI" style={{ width: "100%", height: "auto" }} />
                        </div>

                        {/* Content Section */}
                        <div style={{ width: "100%", maxWidth: "600px", padding: "0 28px", display: "flex", flexDirection: "column", gap: "16px" }}>
                            <CaraAITitle title="No Longer Worry About Missing Out On Tools Or Data." />
                            <Heading1 heading1="All The Data, Consolidated In One Place." />

                            {/* Data Cards */}
                            {DataConso.map((val, id) => (
                                <div key={id} style={{
                                    display: "flex", 
                                    flexDirection: "row", 
                                    alignItems: "center",
                                    gap: "16px", 
                                    marginTop: "16px"
                                }}>
                                    {/* Image */}
                                    <img src={val.img} alt="Feature Icon" style={{ width: "10%", maxWidth: "80px" }} />

                                    {/* Text Content */}
                                    <div style={{ textAlign: "center" }}>
                                        <h4 style={{ fontSize: "17px", fontWeight: "600", color: "#333" }}>{val.title}</h4>
                                        <p style={{ fontSize: "15px", color: "#666" }}>{val.para}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                        {/* Advance Face AI */}
                        <section
                            style={{
                                background: `url(${images.advancefaceai_bg}) center top/cover no-repeat`,
                                padding: "4rem 0",
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "1.5rem",
                                maxWidth: "1200px",
                                margin: "auto",
                            }}
                        >
                            {/* Left Side - Text Content */}
                            <div
                                style={{
                                    width: "100%",
                                    maxWidth: "600px",
                                    color: "white",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "flex-start",
                                    gap: "1rem",
                                    textAlign: "left",
                                    padding: "0 1.5rem",
                                }}
                            >
                                {/* Badge */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        borderRadius: "50px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        padding: "8px 12px",
                                        fontSize: "14px",
                                        backgroundColor: "#24441F",
                                    }}
                                >
                                    <img src={images.Cara} alt="Cara Icon" style={{ marginRight: "8px", width: "20px", height: "20px" }} />
                                    Here's Why You Should Hire Me Today.
                                </div>

                                {/* Heading */}
                                <h1 style={{ fontSize: "24px", fontWeight: "bold", maxWidth: "400px" }}>
                                    Advance Face AI Recognition Algorithm
                                </h1>

                                {/* Description */}
                                <p
                                    style={{
                                        fontSize: "14px",
                                        lineHeight: "1.5",
                                        maxWidth: "450px",
                                    }}
                                >
                                    Cara works with Webtastic AI Nexus, which autonomously indexes web data, social media, news,
                                    interviews, and podcasts, and integrates with over 50 B2B data providers, including LinkedIn,
                                    Apollo, and Google.
                                </p>
                            </div>

                            {/* Right Side - Image */}
                            <div
                                style={{
                                    width: "100%",
                                    maxWidth: "500px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "0 1.5rem",
                                }}
                            >
                                <img src={images.FaceAi} alt="Face AI" style={{ width: "100%", maxWidth: "450px", height: "auto" }} />
                            </div>
                        </section>


                        <section className='container my-10 md:my-16'>
                        </section>
                        <section className=' bg-[#F5F5F5]'>
                            <div className='container py-10 md:py-16 flex flex-col text-center gap-3 md:gap-5'>
                            </div>
                        </section>
                        <div style={{ paddingBottom: 0, marginTop: "25px" }}>
                        <LandingPageTestimonial />
                        </div>
                        <div style={{ paddingBottom: 0, marginTop: "25px" }}>
                        <FaqSection toolName={"EmailVerifier"} />
                        </div>
                        <div style={{ paddingBottom: 0 }}>
                        <IdealCustomers />
                        </div>
                    </>
            }
        </>

    )
}
